import { render, staticRenderFns } from "./PatrolDepts.vue?vue&type=template&id=6b1ce986&scoped=true&"
import script from "./PatrolDepts.vue?vue&type=script&lang=js&"
export * from "./PatrolDepts.vue?vue&type=script&lang=js&"
import style0 from "./PatrolDepts.vue?vue&type=style&index=0&id=6b1ce986&lang=scss&scoped=true&"
import style1 from "./PatrolDepts.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1ce986",
  null
  
)

export default component.exports